import { PDKEmptyValueIcon } from '@/components/ui/pdk-icons';
import { cn } from '@/lib/utils';
import type { Payment } from '@/models/types';
import { Button } from '../../ui/button';
import { PAYMENT_METHOD_OPTIONS_MAP } from './payment-method-selector-combobox';

export const PaymentMethodBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  useAbbreviation = false,
}: {
  value: Payment['method'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  useAbbreviation?: boolean;
}) => {
  return (
    <Button
      variant="ghost"
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {value === null && (
        <>
          <PDKEmptyValueIcon className="h-3.5 w-3.5" />
          <p className="rounded text-xs  text-gray-600">No Contract Status</p>
        </>
      )}
      {PAYMENT_METHOD_OPTIONS_MAP.map((option) => {
        if (option.value === value) {
          return <div key={option.value}>{option.icon}</div>;
        }
      })}

      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {useAbbreviation
            ? PAYMENT_METHOD_OPTIONS_MAP.find(
                (option) => option.value === value,
              )?.abbreviation
            : PAYMENT_METHOD_OPTIONS_MAP.find(
                (option) => option.value === value,
              )?.label}
        </p>
      )}
    </Button>
  );
};
